import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { injectedWallet } from "@rainbow-me/rainbowkit/wallets";
import { http } from "viem";

import { WEB3_CHAIN, WEB3_RPC_URL } from "@/lib/web3/chain";

const walletConnectProjectId =
  import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID?.trim();

export const wagmiConfig = getDefaultConfig({
  appName: "OURS",
  appDescription: "Community-owned meme launchpad on Robinhood Chain",
  appUrl: window.location.origin,
  appIcon: "/brand/ours-app-icon-192.png",
  chains: [WEB3_CHAIN],
  projectId: walletConnectProjectId || "00000000000000000000000000000000",
  ssr: false,
  transports: {
    [WEB3_CHAIN.id]: http(WEB3_RPC_URL),
  },
  wallets: walletConnectProjectId
    ? undefined
    : [
        {
          groupName: "Browser wallet",
          wallets: [injectedWallet],
        },
      ],
});
